import { RunningExperiments, useExperiments } from 'state/experiments';

export const usePaymentCheckoutRedesignExperiment = (skipExposureLogging: boolean = false) => {
  const { variant } = useExperiments();

  return variant(RunningExperiments.PaymentCheckoutRedesign, 'treatment', {
    skipExposureLogging,
  });
};
